import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/global.css';
import '../styles/Landing.css';

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div style={{ borderTop: '1px solid var(--border)', paddingTop: 32, marginBottom: 32 }}>
    <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 14 }}>{title}</h2>
    <div style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.9 }}>{children}</div>
  </div>
);

const Refund = () => (
  <div className="landing-bg" style={{ minHeight: '100vh' }}>
    <div className="landing-orbs">
      <div className="orb1" /><div className="orb2" /><div className="orb3" />
    </div>

    <nav className="navbar">
      <Link to="/" style={{ textDecoration: 'none' }}><div className="logo">my<em>linx</em></div></Link>
      <div className="nav-links">
        <Link to="/login" className="nav-a">Login</Link>
        <Link to="/register" className="btn-main" style={{ padding: '10px 22px', fontSize: 12 }}>Get Started ↗</Link>
      </div>
    </nav>

    <div style={{ maxWidth: 720, margin: '0 auto', padding: '80px 24px 60px' }}>
      <div className="tag" style={{ marginBottom: 20, display: 'inline-flex' }}>Legal</div>
      <h1 style={{ fontSize: 42, fontWeight: 800, marginBottom: 12 }}>Refund & Cancellation Policy</h1>
      <p style={{ color: 'var(--muted)', fontSize: 14, marginBottom: 40 }}>
        Last updated: October 2026 · We want you to be happy with mylinx PRO.
      </p>

      {/* Summary box */}
      <div style={{ background: 'var(--link-bg)', border: '1px solid var(--border)', borderRadius: 12, padding: 24, marginBottom: 40 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--muted)', marginBottom: 12, letterSpacing: 1 }}>QUICK SUMMARY</div>
        <div style={{ fontSize: 14, lineHeight: 1.9, color: 'var(--muted)' }}>
          ✅ Cancel anytime — no questions asked<br />
          ✅ 7-day free PRO trial — no payment required<br />
          ❌ All payments are non-refundable once charged<br />
          📧 Questions? <a href="mailto:support@mylinx.in" style={{ color: 'var(--accent)' }}>support@mylinx.in</a>
        </div>
      </div>

      <Section title="1. Free Trial">
        mylinx.in offers a 7-day free PRO trial to all new users. No payment is required during the trial period. If you do not wish to continue, your account will automatically revert to the free plan at the end of the trial. You will not be charged unless you explicitly subscribe to a paid plan.
      </Section>

      <Section title="2. Subscription Plans">
        <p>mylinx PRO is available in two plans:</p>
        <ul style={{ paddingLeft: 20, marginTop: 10 }}>
          <li style={{ marginBottom: 6 }}>
            <strong style={{ color: 'inherit' }}>Monthly Plan:</strong> ₹199/month (India) or $4.99/month (International). Billed monthly, renews automatically.
          </li>
          <li style={{ marginBottom: 6 }}>
            <strong style={{ color: 'inherit' }}>Yearly Plan:</strong> ₹999/year (India) or $49.99/year (International). Billed annually, renews automatically.
          </li>
        </ul>
      </Section>

      <Section title="3. No Refund Policy">
        <p><strong style={{ color: 'inherit' }}>All payments made to mylinx.in are final and non-refundable.</strong></p>
        <br />
        <p>Once a payment is processed — whether for a monthly or yearly PRO subscription — no refunds will be issued under any circumstances, including but not limited to:</p>
        <ul style={{ paddingLeft: 20, marginTop: 10 }}>
          <li style={{ marginBottom: 6 }}>Change of mind after purchase</li>
          <li style={{ marginBottom: 6 }}>Failure to cancel before the renewal date</li>
          <li style={{ marginBottom: 6 }}>Partial month or partial year usage</li>
          <li style={{ marginBottom: 6 }}>Account suspension or termination due to Terms of Service violations</li>
          <li style={{ marginBottom: 6 }}>Not using the PRO features after subscribing</li>
        </ul>
        <br />
        <p>We strongly recommend using the <strong style={{ color: 'inherit' }}>7-day free trial</strong> to evaluate all PRO features before subscribing.</p>
      </Section>

      <Section title="4. Cancellation Policy">
        <p>You may cancel your subscription at any time from your dashboard or by contacting support.</p>
        <br />
        <p>After cancellation, you will retain PRO access until the end of your current billing period (monthly or yearly). No further charges will be made after cancellation. <strong style={{ color: 'inherit' }}>However, no refund will be issued for the remaining period.</strong></p>
      </Section>

      <Section title="5. Payment Processing">
        <p>Payments in India are processed by <strong style={{ color: 'inherit' }}>Razorpay</strong>. International payments are processed by <strong style={{ color: 'inherit' }}>Dodo Payments</strong>. All transactions are subject to their respective payment policies.</p>
      </Section>

      <Section title="6. Contact Us">
        <p>For any questions about your subscription or cancellation:</p>
        <br />
        <p>📧 <a href="mailto:support@mylinx.in" style={{ color: 'var(--accent)' }}>support@mylinx.in</a></p>
        <p>We respond within 24 hours on business days.</p>
      </Section>
    </div>

    <footer className="footer">
      <Link to="/" style={{ textDecoration: 'none' }}><div className="logo">my<em>linx</em></div></Link>
      <div className="footer-copy">MADE WITH OBSESSION © 2026</div>
      <div className="footer-links">
        <Link to="/about" className="footer-a">About</Link>
        <Link to="/contact" className="footer-a">Contact</Link>
        <Link to="/terms" className="footer-a">Terms</Link>
        <Link to="/privacy" className="footer-a">Privacy</Link>
        <Link to="/refund" className="footer-a">Refund</Link>
      </div>
    </footer>
  </div>
);

export default Refund;